import { ApplicationRoutes } from '../../constants/appRoutes';
import { useMemo } from 'react';
import { BaseNav, RouteAuthenticationRequirement, useAuth, useNavItemStore } from '@cksoftware/react-base';
import { DlmsUser } from '../../globalModels/user/dlmsUser';
import { useSetProfileMutation } from '../../util/profiles/useSetProfileMutation';
import { BaseNavItem } from '@cksoftware/react-base/dist/BaseComponents/Nav/types';

export function useProfileItems(): BaseNavItem {
  const auth = useAuth<DlmsUser>();
  const profileMutation = useSetProfileMutation();
  const routeNav = useNavItemStore((state) => {
    return { items: state.getDefault(), get: state.get };
  });

  return useMemo(() => {
    const subItems: BaseNav.NavItem[] = [
      routeNav.get(ApplicationRoutes.account.myAccount),
      routeNav.get(ApplicationRoutes.account.logout)
    ];
    if (auth.user) {
      auth.user.UserProfiles.forEach((profile) => {
        if (profile.Id != auth.user?.CurrentProfileId) {
          subItems.push({
            text: `Switch to ${profile.FirstName} ${profile.LastName} - ${profile.CompanyName}`,
            onClick: async () => {
              await profileMutation.mutateAsync(profile.Id!);
              window.location.reload();
            },
            authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
            allowedRoles: []
          });
        }
      });
    }

    return {
      text: 'Profile',
      subItems: subItems,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: []
    };
  }, [auth?.user?.CurrentProfileId, auth.user?.UserProfiles]);
}
